import './Skeleton.css';

export function Skel({ h, w, dark, style }) {
  const cls = [
    'skel',
    dark ? 'skel--dark' : '',
    h ? `skel--h${h}` : '',
    w ? `skel--w${w}` : '',
  ]
    .filter(Boolean)
    .join(' ');
  return <div className={cls} style={style} />;
}

export function LedgerRowSkeleton({ dark }) {
  return (
    <div className="skel-ledger-row">
      <Skel dark={dark} />
      <div>
        <Skel w={90} dark={dark} style={{ marginBottom: 6 }} />
        <Skel w={50} dark={dark} />
      </div>
      <Skel w={70} dark={dark} />
      <Skel h={22} w={50} dark={dark} />
      <Skel w={50} dark={dark} />
      <Skel h={22} dark={dark} />
    </div>
  );
}
